export default __webpack_public_path__ + "static/UNA_SOBREBARRIGA-b60b3e95e8be0548d29fff40c7b4b0be.jpg";